export default "__VITE_ASSET__DnpxSzvY__"